// Global 401 handling (spec §6.1/§7): the session ended on the server, so forget the user here too.
// Member-only pages send you to login and back; public pages just switch to the logged-out view.
import { v2Api } from './api';
import { useV2Session } from './stores/session';
import { v2Path } from './routes';

export function handleUnauthorized(error, { router, session }) {
  const status = error && error.response && error.response.status;
  if (status === 401) {
    session.clearUser();
    const route = router.currentRoute.value;
    const loginPath = v2Path('/login');
    const memberOnly = route.matched.some((r) => r.meta && r.meta.requiresUser);
    if (memberOnly && route.path !== loginPath) {
      router.push({ path: loginPath, query: { next: route.fullPath } });
    }
  }
  return Promise.reject(error);
}

let interceptorId = null;

export function installV2AuthInterceptor(router) {
  if (interceptorId !== null) return interceptorId;
  interceptorId = v2Api.interceptors.response.use(
    (response) => response,
    (error) => handleUnauthorized(error, { router, session: useV2Session() })
  );
  return interceptorId;
}
